export function getBaseUrl() {
  return process.env.NODE_ENV === "development"
    ? "http://dev-timnet-bff-sa.nonprod.frontoffice.aioinissaydowa.eu/api/v1/sa"
    : "v1/sa";
}
